import { Amount } from '@client/monolith/core/types/amount';
import { ImageCdnService } from '../types';

const containerStyles = `
  border-spacing: 1rem;
  border-collapse: separate;
  padding: 0;
  margin: 0 auto;
`;

const cardStyles = `
  background-color: #F5F8F9;
  font-size: 12px;
  width: 136px;
  padding: 8px;
  border-radius: 8px;
  box-sizing: border-box;
  border: 1px solid #F0F0F0;
  list-style-type: none;
`;

const imgStyles = `
  display: block;
  border-radius: 8px;
  margin-bottom: 16px;
`;

const nameStyles = `
  font-size: 14px;
  display: block;
  margin-bottom: 16px;
  text-decoration: underline;
  color: #14060A;
`;

const priceStyles = `
  font-weight: 600;
  color: #14060A;
`;

interface Product {
  uuid: string;
  name: string;
  imgSrc?: string;
  formattedPrice?: string;
  price: Amount;
  link: string;
}

export const toProperties = (product: Product) => {
  return {
    uuid: product.uuid,
    name: product.name,
    imgSrc: product.imgSrc,
    price: product.price,
    link: product.link,
  };
};

export const truncateText = (text: string, maxLength: number) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + '...';
  }
  return text;
};

export const createCell = (id: string, product: Product, imageCdnService: ImageCdnService) => {
  const card = document.createElement('td');
  card.setAttribute('style', cardStyles);
  card.setAttribute(id, 'true');
  card.setAttribute('data-aks-properties', JSON.stringify(toProperties(product)));

  const img = document.createElement('img');
  img.setAttribute('src', imageCdnService.createUrl(product.imgSrc, '60'));
  img.setAttribute(id, 'true');
  img.setAttribute('style', imgStyles);

  const name = document.createElement('a');
  name.textContent = truncateText(product.name, 34);
  name.setAttribute('style', nameStyles);
  name.setAttribute('href', product.link);
  name.setAttribute('target', '_blank');
  name.setAttribute(id, 'true');

  const price = document.createElement('p');
  price.textContent = product.formattedPrice;
  price.setAttribute('style', priceStyles);
  price.setAttribute(id, 'true');

  card.appendChild(img);
  card.appendChild(name);

  if (product.formattedPrice) {
    card.appendChild(price);
  }

  return card;
}

export const getContent = (products: { uuid: string; name: string; imgSrc?: string; formattedPrice?: string; price: Amount; link: string }[], pluginKey: string, imageCdnService: ImageCdnService) => {
  const idContainer = `data-${pluginKey}`;
  const idChild = `data-${pluginKey}-child`;

  const table = document.createElement('table');
  table.setAttribute(idContainer, 'true');
  table.setAttribute('style', containerStyles);

  let currentRow: HTMLTableRowElement;

  for (const [index, product] of products.entries()) {
    if (index % 3 === 0) {
      currentRow = document.createElement('tr');
      table.appendChild(currentRow);
    }

    const cell = createCell(idChild, product, imageCdnService);
    currentRow.appendChild(cell);
  }

  return table.outerHTML;
};
